import React, { useEffect } from "react";
import BottomSheet from "./BottomSheet";
import FanClaimButtons from "./FanClaimButtons";
import FanJoinHead from "./FanJoinHead";
import "./FanJoinSheet.css";
import { t } from "../i18n";

// Right after a request goes through (founder, 1.5.1 #17): a signed-out fan
// gets the sign-up ask FIRST, in a sheet over the live status, instead of a
// card under it that nobody scrolled to. "Not now" (required — Apple 5.1.1:
// requesting never needs an account) or signing in reveals the status
// sitting right behind it. While it is open the live card's landing confetti
// rides above the sheet (FanJoinSheet.css), so the celebration stays on top.
const FanJoinSheet: React.FC<{ open: boolean; points: number; onClose: () => void }> = ({ open, points, onClose }) => {
  useEffect(() => {
    if (!open) return;
    document.body.classList.add("fanjoin-sheet-open");
    return () => document.body.classList.remove("fanjoin-sheet-open");
  }, [open]);

  return (
    <BottomSheet open={open} title={t("fanJoin.pointsEarned", { value: points.toLocaleString() })} onClose={onClose} plain>
      <FanJoinHead points={points} />
      <div className="fanjoin-sheet-btns">
        <FanClaimButtons compact onSignedIn={onClose} />
      </div>
      <button type="button" className="fanjoin-sheet-notnow" onClick={onClose}>
        {t("fanRequestsPanel.notNow")}
      </button>
    </BottomSheet>
  );
};

export default FanJoinSheet;
